// Tabs.tsx — segmented tab strip used by the right-side settings panels
// in both Scene and Iso views.
//
// Lives at the top level (not inside SceneBuilder) so both builders can
// import it without setting up a circular dependency between them.
//
// Generic over the tab id type so the host gets autocomplete on the
// `value` prop instead of falling back to strings.

import React from "react";

export function Tabs<T extends string>(props: {
  value: T;
  onChange: (v: T) => void;
  options: Array<{ id: T; label: string }>;
}) {
  return (
    <div style={{
      display: "flex",
      gap: 0,
      background: "var(--bg)",
      border: "1px solid var(--panel-border, #1f1f24)",
      borderRadius: 3,
      padding: 2,
    }}>
      {props.options.map((opt) => {
        const active = opt.id === props.value;
        return (
          <button
            key={opt.id}
            onClick={() => props.onChange(opt.id)}
            style={{
              flex: 1,
              background: active ? "var(--accent, #0b72b7)" : "transparent",
              color: active ? "#fff" : "var(--muted, #9aa0aa)",
              border: "none",
              padding: "4px 8px",
              borderRadius: 2,
              fontSize: 11,
              fontWeight: active ? 600 : 500,
              cursor: "pointer",
              pointerEvents: "auto",
              transition: "background 80ms ease",
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
